import { select } from 'redux-most';
import { switchMap, fromFuture } from 'most-adjunct';
import * as mostc from '../../../crosscutting/mostc';
import * as most from 'most';
import * as r from 'ramda';
import * as signals from '../../signals';
import * as messages from '../../../domain/messages';
import Future from 'fluture';

export default function createOptOutEpic(
  optOutRepo,
  emitEvent,
  cleanseRepo,
) {
  return (actions, store) => r.pipe(
    select(signals.OPT_OUT),
    switchMap((action) => {
      const state = store.getState();
      const categoryKeyIdMap = state.config.categories;
      const preserve = state.config.cookiesToPreserve;

      const ids = r.pipe(
        r.values,
        r.map(r.prop('id')),
      )(categoryKeyIdMap);

      const cleansing = cleanseRepo(preserve);

      const optingOut = cleansing.chain(() => {
        return optOutRepo(ids, 90)
          .map(r.tap(() => {
            emitEvent('@upm/opted-out', {});
          }))
          .map(r.tap(() => {
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }))
          .map(() => messages.optedOut());
      });

      return most.merge(
        most.of(messages.optOutRequested()),
        fromFuture(optingOut),
      );
    }),
  )(actions);
}



// WEBPACK FOOTER //
// ./src/application/epics/privacy/optOut.js